import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-account-number-pipe-page-ui',
    template: '',
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class AccountNumberPipePageComponent {}
